import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const USER_REFERENCE_URLS: generalConst = {
  BASE_URL: ROUTES.USERSREFERENCE,
  USER_DETAIL: `${ROUTES.USERSREFERENCE}/SecondStep`,
};

export interface IUserReferenceProps {
  resetState: () => {};
}
